export default __webpack_public_path__ + "static/media/2_documents.e2069ffa.svg";